let mainPath = "/appointments";
let viewFolder = "Appointment";

module.exports = [
    {
        path: mainPath,
        name: 'appointments',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    },
    {
        path: mainPath+'/view/:id',
        name: 'appointment',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/View.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    },
    {
        path: mainPath+'/followUp',
        name: 'customerFollowUp',
        component: () => import('../views/'+viewFolder+'/CustomerFollowUp.vue')
    }
]